import ClaimInvoice from 'models/claims/claimInvoice/ClaimInvoice';
import ClaimJob from 'models/claims/claimJob/Model.ClaimJob';
import ClaimJobItemPayee from 'models/claims/claimJobItemPayee/Model.ClaimJobItemPayee';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import ClaimJobPayment from '../claimJobPayment/Model.ClaimJobPayment';
import claimJobPaymentItemFindApi from './find/Api.ClaimJobPaymentItem.Find';
import claimJobPaymentItemListApi from './list/Api.ClaimJobPaymentItem.List';

export default class ClaimJobPaymentItem
  extends Model<Model.IClaimJobPaymentItem>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobPaymentItem>
{
  id: number;
  totalAmountBeforeTax: number = 0; // parts + labours + others
  gstHstAmount: number = 0;
  provincialSalesTaxAmount: number = 0;
  totalDeductibleAmount: number = 0.0;
  paymentMethodCode: string;
  currency: string = 'CAD';
  createdAtLocal: string;

  claimJobId: number;
  claimJob: ClaimJob;
  claimJobItemPayee?: ClaimJobItemPayee;
  claimJobPaymentId?: number;
  claimJobPayment?: ClaimJobPayment;
  claimInvoice?: ClaimInvoice;
  createdById?: number;
  createdBy?: User;

  readonly jobNumber?: string;

  isCancelled: boolean;

  //#region Payment
  isPaymentSentManually?: boolean;
  isPaymentSentViaUsBank?: boolean;
  readonly isPaymentSent?: boolean; // isPaymentSentViaUsBank || isPaymentSentManually
  usBankVirtualCardId?: string;
  paymentRequestedAtUtc?: string;
  //#endregion

  get total(): number {
    return this.totalAmountBeforeTax - this.totalDeductibleAmount + this.gstHstAmount + this.provincialSalesTaxAmount;
  }

  constructor(
    data: Partial<Model.IClaimJobPaymentItem> | Utils.FormData<Model.IClaimJobPaymentItem>,
    language?: Locale.Languages
  ) {
    super(
      {
        claimJobItemPayee: ClaimJobItemPayee,
        createdBy: User,
        claimJob: ClaimJob,
        claimJobPayment: ClaimJobPayment,
        claimInvoice: ClaimInvoice,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }

  static convertClaimJobAggregateToClaimJobPaymentItem(
    claimJobAggregate: Model.IClaimJobAggregate
  ): Partial<ClaimJobPaymentItem> {
    return {
      claimJobId: claimJobAggregate.jobId,
      totalAmountBeforeTax: claimJobAggregate.ttl, // parts + labours + others
      totalDeductibleAmount: claimJobAggregate.deduct,
      gstHstAmount: claimJobAggregate.gstHstRounded,
      provincialSalesTaxAmount: claimJobAggregate.provincialSalesTaxRounded,
      currency: claimJobAggregate.currency,
      paymentMethodCode: claimJobAggregate.paymentMethodCode,
      claimJobItemPayee: {
        payeeId: claimJobAggregate.payee?.payeeId,
        clientId: claimJobAggregate.payee?.clientId,
        dealerId: claimJobAggregate.payee?.dealerId,
        payeeTypeId: claimJobAggregate.payee?.payeeTypeId,
      } as ClaimJobItemPayee,
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await claimJobPaymentItemFindApi(params);
    return {
      ...rest,
      payload: new ClaimJobPaymentItem(payload),
    };
  }

  static async list(body?: Api.Finance.ClaimJobPaymentItem.List.IRequest) {
    const { payload, ...rest } = await claimJobPaymentItemListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimJobPaymentItem(it)),
        count: payload.count,
      },
    };
  }
}
